import config from '@/config/config';

import Index from '@/pages/config/type-media/index.vue';
import List from '@/pages/config/type-media/list/list.vue';
import View from '@/pages/config/type-media/view/view.vue';
import New from '@/pages/config/type-media/new/new.vue';
import Edit from '@/pages/config/type-media/edit/edit.vue';

const modulePermission = config.modules.typeMedia;

export default {
  path: '/type-media',
  name: 'type-media',
  component: Index,
  meta: {
    requiresAuth: true,
    modulePermission: modulePermission,
    requiresPermission: 'enabled_read',
  },
  children: [
    {
      path: 'list',
      name: 'type-media-list',
      component: List,
      meta: {
        modulePermission: modulePermission,
        requiresPermission: 'enabled_read',
      },
    },
    {
      path: ':id',
      name: 'type-media-view',
      component: View,
      meta: {
        modulePermission: modulePermission,
        requiresPermission: 'enabled_read',
      },
      props: true,
    },
    {
      path: 'new',
      name: 'type-media-new',
      component: New,
      meta: {
        modulePermission: modulePermission,
        requiresPermission: 'enabled_create',
      },
    },
    {
      path: ':id/e',
      name: 'type-media-edit',
      component: Edit,
      meta: {
        modulePermission: modulePermission,
        requiresPermission: 'enabled_edit',
      },
      props: true,
    },
  ],
};
